const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410302009',
            ext_path: '河南省 洛阳市 老城区 道北路街道',
            cid: '1',
            pid: '410302',
            name: '道北路街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.43866, 34.693236]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302005',
            ext_path: '河南省 洛阳市 老城区 东北隅街道',
            cid: '2',
            pid: '410302',
            name: '东北隅街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.483087, 34.68697]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302004',
            ext_path: '河南省 洛阳市 老城区 东南隅街道',
            cid: '3',
            pid: '410302',
            name: '东南隅街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.484673, 34.681068]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302007',
            ext_path: '河南省 洛阳市 老城区 洛浦街道',
            cid: '4',
            pid: '410302',
            name: '洛浦街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.478837, 34.672931]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302008',
            ext_path: '河南省 洛阳市 老城区 邙山街道',
            cid: '5',
            pid: '410302',
            name: '邙山街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.436906, 34.719243]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302006',
            ext_path: '河南省 洛阳市 老城区 南关街道',
            cid: '6',
            pid: '410302',
            name: '南关街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.481461, 34.67769]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302003',
            ext_path: '河南省 洛阳市 老城区 西北隅街道',
            cid: '7',
            pid: '410302',
            name: '西北隅街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.475468, 34.686567]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302001',
            ext_path: '河南省 洛阳市 老城区 西关街道',
            cid: '8',
            pid: '410302',
            name: '西关街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.464127, 34.682822]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410302002',
            ext_path: '河南省 洛阳市 老城区 西南隅街道',
            cid: '9',
            pid: '410302',
            name: '西南隅街道',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.474961, 34.680398]
        }
    }
];

export { d };
